import styled from 'styled-components';

export const ActionArea = styled.div`
  margin-top: ${({ theme }) => theme.spacing.level6};
`;

export const BackLinkArea = styled.div`
  margin-top: ${({ theme }) => theme.spacing.level5};
`;
